import React from "react";
import { EYEBROW } from "../../lib/typography.js";
import { cn } from "../../lib/utils.js";
import type { PeopleFieldSection as Section } from "./people-field-model.js";

/**
 * One section of the open list. A titled section is a listbox `group` named
 * by its header (the APG grouped-listbox shape: the header is
 * presentational); the one-row sections — Assign to me, the typed name — sit
 * in the listbox directly, the typed name below a rule.
 */
export function PeopleFieldSection({
  section,
  headerId,
  children,
}: {
  readonly section: Section;
  readonly headerId: string;
  readonly children: React.ReactNode;
}): React.ReactElement {
  if (section.title === null) {
    return section.key === "typed" ? (
      <div
        role="presentation"
        className="mt-1.5 border-t border-pb-border pt-1.5"
      >
        {children}
      </div>
    ) : (
      <>{children}</>
    );
  }
  return (
    <div role="group" aria-labelledby={headerId}>
      <div
        role="presentation"
        className={cn(
          "flex items-center justify-between px-2 pb-1 pt-2",
          EYEBROW,
        )}
      >
        <span id={headerId}>{section.title}</span>
        {section.count !== null ? (
          <span aria-hidden="true">{section.count}</span>
        ) : null}
      </div>
      {children}
    </div>
  );
}
